import HomeCard from "./homeCard";
import {
  showcaseDate,
  formatDate,
  formatDateWeekday,
  showcaseApplicationDeadlineDate,
} from "../../../utils/showcaseDates";

const bulletPoints = [
  "Exposure to industry leaders, investors and collaborators",
  "Valuable networking opportunities",
  "An opportunity to showcase your innovation in wildfire prevention",
];

const bulletPoints2 = [
  "Exposure to industry leaders, investors and collaborators",
  "Valuable networking opportunities",
  "New innovations with great impact potential",
];

const bulletPoints3 = [
  "Exposure to industry leaders, investors and collaborators",
  "Valuable networking opportunities",
  "An opportunity to showcase your innovation in wildfire prevention",
  "New innovations with great impact potential",
];

const CardInnovatorShowcase = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="showcase"
      title="Wildfire Innovation Showcase"
      titleColor="var(--orange)"
      image="./images/home/card-innovative-showcase.jpg"
      content={[
        {
          type: "header-H4",
          color: "var(--gold)",
          text: `${formatDateWeekday(showcaseDate)} <br /> 12 pm PST`,
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: `Hosted by the Catastrophic Wildfire Prevention Consortium, in
          collaboration with <a href="https://venturestarters.com/" target="_blank"> Venture Starters</a>.`,
        },
        {
          type: "header-H4",
          color: "var(--green)",
          text: `Featuring 7+ trailblazing ventures`,
        },
        {
          type: "list",
          headerColor: "var(--cornflower-blue)",
          header: "Unlock your potential through:",
          list: bulletPoints,
        },
        {
          type: "paragraph",
          text: `<span style="color: var(--gold);"> Apply by ${formatDate(
            showcaseApplicationDeadlineDate
          )} 5 pm PST</span> to be considered for presenting`,
        },
        {
          type: "paragraph",
          text: 'Questions: <a href="mailto:contact@preventwildfire.world">contact@preventwildfire.world<a> ',
        },
        {
          type: "button",
          text: "Apply to Present",
          link: "https://docs.google.com/forms/d/e/1FAIpQLSeSs3XsYEIguFjQ4i9jBQ9nxmYNmNDnhbv_q4qeOtQzWani4g/viewform",
          color: "var(--green)",
        },
        {
          type: "paragraph",
          text: 'Our April Showcase garnered great reception with over 200 guests and 6,500+ views! <a href="https://www.youtube.com/watch?v=4jI0sPQ19Cg&ab_channel=CatastrophicWildfirePreventionConsortium" target="_blank">Viewable on YouTube</a>.',
        },
        {
          type: "list",
          headerColor: "var(--cornflower-blue)",
          header: "Join Us. Experience...",
          list: bulletPoints2,
        },
        {
          type: "paragraph",
          text: '<a href="/showcase/innovations">Learn more ...</a>',
          color: "var(--white)",
        },
        {
          type: "button",
          text: "Register",
          link: "https://venturestarters.com/",
          color: "var(--orange)",
        },
      ]}
    />
  );
};

export default CardInnovatorShowcase;
